<template>
    <div>
		<tab name="2"></tab>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/daping/pw/save')" type="primary" icon="el-icon-plus" size="small"
                @click="$refs.saleadd.show()">添加演出</el-button>
        </div>
        <div class="page-list-box">
			<div class="color-danger">这里展示的是未取消订单的数据，即支付成功且未取消的票数<br>这里的票数对应人头数，比如双人票，那么票数显示是2</div>
			<div class="MT10">面板访问地址:
				<el-link
					type="primary"
					size="small"
					:href="`${ssfb}/entryData`"
					target="_blank"
					>{{ssfb}}/entryData</el-link>
			</div>
			
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe class="MT20">
				<el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="title" label="演出标题" show-overflow-tooltip min-width="150"></el-table-column>                
                <el-table-column prop="realTicketNum" label="当前真实售票"></el-table-column>
                <el-table-column  label="对外展示售票">
					<template slot-scope="scope">
						{{scope.row.showTicketNum}} （{{scope.row.ratio}}%）
					</template>
				</el-table-column>
                <el-table-column prop="totalStock" label="库存总票数">
					<template slot-scope="scope">
						<span v-if="scope.row.totalStock && scope.row.totalStock > 0">{{scope.row.totalStock}}</span><span v-else>未设置票品库存</span>
					</template>
				</el-table-column>
                <el-table-column label="报批人数">
					<template slot-scope="scope">
						<span v-if="scope.row.reportNum">{{scope.row.reportNum}}</span><span v-else>未设置报批人数</span>  <span v-if="scope.row.reportRatio">（{{scope.row.reportRatio}}%）</span></span>
					</template>
				</el-table-column>
				<el-table-column prop="addTime" label="添加时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/gongan/report/sell/update') && scope.row.status == 1 " type="text" size="small" icon="el-icon-edit" @click="$refs.saleadd.show(scope.row)">编辑
                        </el-button>
						<el-button v-if="$utils.have('/gongan/report/sell/del') && scope.row.status == 1 " type="text" size="small" icon="el-icon-delete" @click="del(scope.row.id)" >删除
						</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <sale-add ref="saleadd" @onUpdate="getDataList"></sale-add>
    </div>
</template>
<script>
import SaleAdd from "./components/saleadd.vue";
import Tab from './components/tab'
const defaultParams = {
    pageNo: 1,
}
export default {
    components: { SaleAdd,Tab },

    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
			ssfb:process.env.VUE_APP_SSFB_URL
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/gongan/report/sell/list",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		//删除事件
		del(id){
		    this.$confirm('删除后，该演出不再对外展示到数据看板，是否确认删除？', '删除', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: '/gongan/report/sell/del',
		            method: 'POST',
		            params: {id:id}
		        }).then(res => {
		            const { state, msg } = res.data;
		            if( state == 1 ){
		                this.getDataList();
		            }else{
		                this.$message.error(msg || '删除失败');
		            }
		        }).catch(() => {
		            this.$message.error('删除错误');
		        }).finally(() => {
		            this.listLoading = false;
		        });
		    })
		},
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>